import { Link } from "react-router-dom";
import { contents } from "@/mocks/contents";

export default function HotTags() {
  const tagCount = new Map<string, number>();
  contents.forEach((c) => c.tags.forEach((t) => tagCount.set(t, (tagCount.get(t) ?? 0) + 1)));
  const tags = Array.from(tagCount.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, 14);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3.5">
        <i className="ri-price-tag-3-line text-accent-500 text-lg" />
        <h2 className="text-sm md:text-base font-semibold text-foreground-900 font-heading">热门标签</h2>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map(([tag]) => (
          <Link
            key={tag}
            to={`/search?q=${encodeURIComponent(tag)}`}
            className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 hover:bg-accent-100 hover:text-accent-900 transition-colors cursor-pointer"
          >
            {tag}
          </Link>
        ))}
      </div>
    </div>
  );
}